<div>
  <net-icon
    *ngIf="icon"
    [size]="iconSize"
    [ngClass]="getIconClasses()"
    [name]="icon"
  ></net-icon>
  <ng-content></ng-content>
</div>
